// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"37b7fcb9cc64a6b0","5763":"1bdbcd77cbcf088c","7222":"3452c52bba4c968b","7937":"94bb5e23104583fb"}[chunkId] + ".js";
};